import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_FAVORITE, EMPTY_USER} from '@models/empty';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {HttpClient} from '@angular/common/http';
import {CommonService} from '@services/common.service';
import {AuthenticationService} from '@services/authentification.service';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {environment} from '~/environments/environment';
import {UntypedFormControl} from '@angular/forms';
import {City} from '@models/city';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';

@Component({
    selector: 'app-localisation',
    templateUrl: './localisation.component.html',
    styleUrls: ['./localisation.component.scss']
})
export class LocalisationComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    user: User = Object.assign({}, EMPTY_USER);
    cityControl = new UntypedFormControl();
    zipcodeControl = new UntypedFormControl();
    cities: City[] = [];
    zipCode: City[] = [];
    firstCity = true;
    firstZipCode = true;
    secteur = '';

    findIris = null;
    detectIris = '';

    constructor(public cityService: CityService,
                public adService: AdService,
                private http: HttpClient,
                public commonService: CommonService,
                public authenticationService: AuthenticationService,
                private router: Router,
                public dialog: MatDialog) {
    }

    ngOnInit(): void {
        if (this.favorite.iris != '') {
            this.secteur = this.favorite.iris.substring(0, 7);
        }
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
        }
        this.cityControl.valueChanges
            .pipe(
                startWith(this.favorite.ad_city.name),
                debounceTime(500),
                // tap(() => this.isLoading = true),
                switchMap(value => {
                    if (this.firstCity === true) {
                        this.firstCity = false;
                        return of([this.favorite.ad_city]);
                    } else {
                        return this.cityService.search(this.favorite.ad_city.name);
                    }
                })
                // .pipe(finalize(() => this.isLoading = false))
            )
            .subscribe(d => {
                $('.citySpinner').hide();
                this.cities = d;
            });

        this.zipcodeControl.valueChanges
            .pipe(
                startWith(this.favorite.ad_city.zip_code),
                debounceTime(500),
                switchMap(value => {
                    if (this.firstZipCode === true) {
                        this.firstZipCode = false;
                        return of([this.favorite.ad_city]);
                    } else {
                        return this.cityService.search(this.favorite.ad_city.zip_code);
                    }
                })
            )
            .subscribe(d => {
                $('.citySpinner').hide();
                this.zipCode = d;
            });
    }

    edit(event, fields = '') {
        if (fields === 'secteur') {
            this.favorite.iris = this.secteur;
        }
        if (fields == 'adress' && this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length > 0) {
            if (this.findIris != null) {
                clearTimeout(this.findIris);
            }
            if (this.favorite.adress.length > 10) {
                this.findIris = setTimeout(() => {
                    this.http.post<any>(environment.apiUrl + 'app/search_iris', {
                        address: this.favorite.adress,
                        city_code: this.favorite.ad_city.city_code
                    }).subscribe(result => {
                        this.detectIris = result.Id;
                    }, error => {
                        this.detectIris = '';
                    });
                }, 1000);
            } else {
                this.detectIris = '';
            }
        }

        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    changeCity(value) {
        let fav = Object.assign({}, this.favorite);
        fav.ad_city = value;
        this.adService.saveCity(fav).subscribe(result => {
            this.favorite.ad_city = result;
            this.favorite = this.adService.updateValues(this.favorite);
        }, error => {
            console.log('Error');
            console.log(error);
        });
    }
}
